'use es6';

import { isFile } from 'FileManagerCore/utils/FoldersAndFiles';
function getDoesObjectAlreadyExist(object, objectList, name, objectIsFile) {
  const matchingObject = objectList.find(item => {
    return object !== item && item.get('name') === name && (objectIsFile ? isFile(item) && item.get('extension') === object.get('extension') : !isFile(item));
  });
  return !!matchingObject;
}
export function getDoesFolderNameAlreadyExist(folder, filesAndFolders, name) {
  return getDoesObjectAlreadyExist(folder, filesAndFolders, name, false);
}
export function getDoesFileNameAlreadyExist(file, filesAndFolders, name) {
  return getDoesObjectAlreadyExist(file, filesAndFolders, name, true);
}